import{a as r}from"../chunk-PTPXZ7BA.mjs";import{d as e,e as o}from"../chunk-G6GIS7LZ.mjs";var c=new e({locale:"es",localeFallback:"en",locales:{es:r,en:o}});export{c as faker};
